import type { IAgentTool } from '../IAgentTool';
import { normalizeField } from '../../../assistant/utils/conditionEvaluation';

export const heatmapTool: IAgentTool = {
  name: 'heatmap',
  description: 'Apply a heatmap (color scale) overlay by a field. Supports numeric fields (tenure, salary), date fields (startDate, joinDate), and structural fields (level, directReports, totalReports). Supports custom min/max colors.',
  parameters: {
    type: 'object',
    properties: {
      field: { type: 'string', description: 'Field to visualize. Use "tenure" for years of service, "level" for hierarchy depth, "directReports" for team size, "startDate"/"joinDate" for hire date, or any node attribute.' },
      min_color: { type: 'string', description: 'Hex color for the low end of the scale (e.g., "#ffffff" for white)' },
      max_color: { type: 'string', description: 'Hex color for the high end of the scale (e.g., "#166534" for dark green)' },
    },
    required: ['field'],
  },
  supportedDiagramTypes: [],
  tier: 'visual',
  category: 'display',

  async execute(params, context) {
    const field = normalizeField(String(params.field ?? '').trim());
    if (!field) {
      return { success: false, summary: 'Missing field for heatmap.' };
    }

    const minColor = typeof params.min_color === 'string' ? params.min_color.trim() : undefined;
    const maxColor = typeof params.max_color === 'string' ? params.max_color.trim() : undefined;

    const categorical = field === 'flightRisk';
    const ruleId = context.stores.viewRules.addViewRule(categorical ? 'colorBy' : 'heatmap', { field, minColor, maxColor });

    const colorNote = minColor || maxColor
      ? ` (${minColor ?? 'default'} → ${maxColor ?? 'default'})`
      : '';

    return {
      success: true,
      summary: categorical
        ? 'Colored recorded flight risk as Low, Medium, or High. Missing values remain neutral.'
        : `Applied heatmap by ${field}${colorNote}.`,
      createdResourceIds: ruleId ? [ruleId] : [],
    };
  },
};
